import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=adf777bc&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=adf777bc&lang=scss"
import style1 from "./OrderDetails.vue?vue&type=style&index=1&id=adf777bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf777bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adf777bc')) {
      api.createRecord('adf777bc', component.options)
    } else {
      api.reload('adf777bc', component.options)
    }
    module.hot.accept("./OrderDetails.vue?vue&type=template&id=adf777bc&scoped=true", function () {
      api.rerender('adf777bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrderDetails.vue"
export default component.exports